import React, { useContext, useState, useEffect } from "react";
import { FileContext } from "../context/FileContext";
import { getFileIcon } from "../utils/Icon";
import { getBinData } from "../api/folderapi";
import { toast } from "react-hot-toast";
import { HiDotsVertical } from "react-icons/hi";
import {  useRef } from "react";
import { FaList } from "react-icons/fa6";
import { IoGridOutline } from "react-icons/io5";

const Trash = () => {
  const { files, setFiles, viewType, setViewType } = useContext(FileContext);
  const [data, setData] = useState([]);
   const menuRef = useRef(null);

  const [openMenuId, setOpenMenuId] = useState(null);

  const restoreFile = (id) => {
    setFiles((prev) =>
      prev.map((file) => (file._id === id ? { ...file, trashed: false } : file))
    );
    setData((prev) => prev.filter((file) => file._id !== id));
    toast.success("File restored");
    setOpenMenuId(null); // close menu after action
  };

  const deleteForever = (id) => {
    setFiles((prev) => prev.filter((file) => file._id !== id));
    setData((prev) => prev.filter((file) => file._id !== id));
    toast.success("File deleted permanently");
    setOpenMenuId(null); // close menu after action
  };

  useEffect(() => {
    getBinData()
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);


    useEffect(() => {
      const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
          setOpenMenuId(null);
          
        }
      };
  
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

  return (
    <div className="">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-secondary">Bin</h2>

        <div className="flex items-center gap-3">
          {/* Filter */}
          <div className="w-10 h-10 border border-gray-300 rounded-md flex items-center justify-center bg-white hover:bg-gray-100">
            <img src="/assets/filter.png" alt="filter" className="w-5 h-5" />
          </div>

          {/* View Switch */}
           <div className="flex border border-gray-300  rounded-md overflow-hidden w-fit h-10">
                     <button
                       className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
                         viewType === "list" ? "bg-four text-black" : "text-secondary "
                       }`}
                       onClick={() => {
                         setViewType("list");
                         /* setIsMenuOpen(false); */
                       }}
                     >
                       <FaList />
                     </button>
         
                     <button
                       className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
                         viewType === "grid" ? "bg-four text-black" : "text-secondary "
                       }`}
                       onClick={() => {
                         setViewType("grid");
                         /* setIsMenuOpen(false); */
                       }}
                     >
                       <IoGridOutline />
                     </button>
                   </div>
        </div>
      </div>

      {data.length === 0 ? (
        <p className="text-gray-600">No trashed items.</p>
      ) : viewType === "grid" ? (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-5 mb-10" ref={menuRef}>
          {data.map((file) => (
            <div
              key={file._id}
              className="relative flex flex-col items-center bg-four p-1 border border-gray-300 rounded-md overflow-hidden"
            >
              {/* Image */}
              <div className="w-full h-24 flex items-center justify-center">
                <img
                  src={getFileIcon(file.name, file.url)}
                  alt={file.name}
                  className={`w-full h-full object-contain${
                    file.isLocked && !file.isDirectory
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                />
              </div>

              {/* File Name */}
              <span className="font-medium text-secondary w-full text-xs px-2 py-2">
                {file.name.slice(0, 10)}
              </span>

              {/* Menu Icon */}
              <div className="absolute top-2 right-2">
                <HiDotsVertical
                  fontSize={20}
                  className="text-icon cursor-pointer  rounded hover:bg-gray-200"
                  onClick={() =>
                    setOpenMenuId(openMenuId === file._id ? null : file._id)
                  }
                />
              </div>

              {/* Dropdown menu */}
              {openMenuId === file._id && (
                <div className="absolute top-8 right-2 bg-white border border-gray-300 rounded-lg shadow-lg flex flex-col gap-2 px-3 py-2 w-28 z-50">
                  <button
                    onClick={() => restoreFile(file._id)}
                    className="text-secondary font-medium text-xs rounded-md px-4 py-2 hover:bg-gray-100 transition text-left"
                  >
                    Restore
                  </button>
                  <button
                    onClick={() => deleteForever(file._id)}
                    className="text-secondary font-medium text-xs rounded-md px-4 py-2 hover:bg-gray-100 transition text-left"
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="w-full overflow-x-auto mt-5">
          <table className="min-w-[700px] w-full table-auto text-sm text-left">
            <thead className="text-xs md:text-sm">
              <tr className="text-secondary font-semibold">
                <th className="p-2 md:p-4">Icon</th>
                <th className="p-2 md:p-4">Filename</th>
                <th className="p-2 md:p-4">Action</th>
              </tr>
            </thead>
           <tbody>
  {data.map((file) => (
    <tr
      key={file._id}
      className="hover:bg-third transition-all duration-200 relative"
    >
      <td className="p-2 md:p-4">
        <img
          src={getFileIcon(file.name, file.url)}
          alt={file.name}
          className={`w-10 h-10 object-contain ${
            file.isLocked && !file.isDirectory
              ? "blur-md opacity-50 cursor-not-allowed"
              : ""
          }`}
        />
      </td>

      <td className="p-2 md:p-4">{file.name}</td>

      <td className="p-2 md:p-4 relative">
        {/* Menu Icon */}
        <HiDotsVertical
          fontSize={20}
          className="text-icon cursor-pointer rounded hover:bg-gray-200 "
          onClick={() =>
            setOpenMenuId(openMenuId === file._id ? null : file._id)
          }
        />

        {/* Dropdown Menu */}
        {openMenuId === file._id && (
          <div className="absolute top-full right-0 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg flex flex-col gap-2 px-3 py-2 w-28 z-50">
            <button
              onClick={() => restoreFile(file._id)}
              className="text-secondary font-medium text-xs rounded-md px-4 py-2 hover:bg-gray-100 transition text-left"
            >
              Restore
            </button>
            <button
              onClick={() => deleteForever(file._id)}
              className="text-secondary font-medium text-xs rounded-md px-4 py-2 hover:bg-gray-100 transition text-left"
            >
              Delete
            </button>
          </div>
        )}
      </td>
    </tr>
  ))}
</tbody>

          </table>
        </div>
      )}
    </div>
  );
};

export default Trash;
